import { render, staticRenderFns } from "./CloneEvents.vue?vue&type=template&id=563c7e78&"
import script from "./CloneEvents.vue?vue&type=script&lang=js&"
export * from "./CloneEvents.vue?vue&type=script&lang=js&"
import style0 from "./CloneEvents.vue?vue&type=style&index=0&id=563c7e78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports